"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2026],{

/***/ 36344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ Flex; }
/* harmony export */ });
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17016);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89703);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25989);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledFlex = _emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .Z.div((_a) => {
  var _b = _a, { theme } = _b, props = __objRest(_b, ["theme"]);
  return [
    _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F,
    {
      display: "flex",
      flexDirection: props.direction,
      gap: theme.spacing[props.gap],
      columnGap: theme.spacing[props.gapX],
      rowGap: theme.spacing[props.gapY],
      justifyContent: buildVariant(props.justify),
      alignItems: buildVariant(props.align)
    }
  ];
});
const buildVariant = (variant) => {
  switch (variant) {
    case "start":
      return "flex-start";
    case "end":
      return "flex-end";
    default:
      return variant;
  }
};
StyledFlex.defaultProps = {
  direction: "row",
  gap: "s0",
  gapX: "s0",
  gapY: "s0",
  justify: "start",
  align: "baseline"
};
const Flex = (props) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(StyledFlex, __spreadValues({}, props));




/***/ }),

/***/ 12026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MiniNotification": function() { return /* binding */ MiniNotification; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20348);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53769);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89703);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38815);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63438);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _desktop_organisms_MiniNotificationItem__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64396);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5167);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17016);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88123);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36344);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28247);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);\n  width: 384px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  a {\n    color: #a7abc3;\n    text-decoration: none;\n    &:hover {\n      color: #82869e;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 24px;\n  color: #82869e;\n  padding: 10px 16px;\n  background-color: #f8f8fc;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










const Wrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Shape */ .b)(_templateObject());
const LastLinkWrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k)(_templateObject1());
const Title = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div(_templateObject2());
const MiniNotification = (param)=>{
    let { onHide  } = param;
    const { notifications , promotions , handleNotificationClicked , loading , status ,  } = (0,contexts__WEBPACK_IMPORTED_MODULE_7__/* .useNotification */ .lm)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    if (status === contexts__WEBPACK_IMPORTED_MODULE_7__/* .PageStatus.EMPTY */ .ti.EMPTY && !loading && false) {}
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
        backgroundColor: "white",
        borderRadius: "l",
        children: [
            !!promotions.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("KHUYẾN M\xc3I")
                    }),
                    promotions.slice(0, 3).map((promotion)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_desktop_organisms_MiniNotificationItem__WEBPACK_IMPORTED_MODULE_9__/* .MiniNotificationItem */ .f, {
                            title: promotion.label,
                            message: promotion.subLabel,
                            isRead: true,
                            onClick: ()=>{
                                if (promotion.url) {
                                    onHide && onHide();
                                    router.push(promotion.url);
                                }
                            },
                            avatar: promotion.imageUrl
                        }, promotion.id))
                ]
            }),
            !!notifications.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("ĐƠN H\xc0NG")
                    }),
                    notifications.slice(0, 3).map((notification)=>{
                        if (notification) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_desktop_organisms_MiniNotificationItem__WEBPACK_IMPORTED_MODULE_9__/* .MiniNotificationItem */ .f, {
                                title: notification.title,
                                message: notification.message,
                                isRead: notification.is_read,
                                onClick: async ()=>{
                                    onHide && onHide();
                                    await handleNotificationClicked(notification);
                                    if (notification.deepLink) {
                                        router.push(notification.deepLink);
                                    } else if (notification.order) {
                                        router.push({
                                            pathname: "/account/orders/[orderId]",
                                            query: {
                                                orderId: notification.order.orderId
                                            }
                                        }, {
                                            pathname: "/account/orders/".concat(notification.order.orderId)
                                        });
                                    }
                                },
                                time: notification.created_at,
                                avatar: !notification.order ? notification.image_url : notification.order.imageUrl
                            }, notification.id);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LastLinkWrapper, {
                padding: "s8",
                align: "center",
                justify: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), _objectSpreadProps(_objectSpread({
                    href: "/notification",
                    as: "/notification",
                    onClick: onHide,
                    prefetch: false
                }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_10__/* .getTrackingData */ .O)({
                    isTrackContent: true,
                    regionName: "MiniNotification",
                    contentName: "viewNotificationFromMiniNotification",
                    target: "Notification"
                })), {
                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Xem tất cả th\xf4ng b\xe1o")
                }))
            })
        ]
    });
};


/***/ }),

/***/ 64396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ MiniNotificationItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20348);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89703);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17016);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79185);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31439);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  margin-right: 16px;\n  width: 64px;\n  height: 64px;\n  border: 1px solid #e0e0e0;\n  border-radius: 50%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  background-color: unset;\n  border-radius: 50%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  width: calc(100% - 80px);\n  .message {\n    font-size: 14px;\n    color: #848788;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    line-height: 18px;\n    margin-top: 4px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 100%;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 24px;\n  color: #434657;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  margin-right: 8px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 12px;\n  color: #82869e;\n  line-height: 16px;\n  min-width: fit-content;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 13px;\n  color: #82869e;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  line-height: 20px;\n  margin-top: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div((param)=>{
    let { isRead  } = param;
    return "\n  padding: 16px;\n  display: flex;\n  cursor: pointer;\n  border-bottom: 1px solid #e0e0e0;\n  background-color: ".concat(isRead ? "white" : "rgb(255, 242, 242)", ";\n");
});
const Avatar = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject());
const ProductImageWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject1());
const ContentWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject2());
const HeaderWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject3());
const TitleWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span */ .Z.span(_templateObject4());
const TimeWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span */ .Z.span(_templateObject5());
const MessageWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span */ .Z.span(_templateObject6());
const MiniNotificationItem = (props)=>{
    const date = new Date(props.time);
    const formatDate = "".concat(date.getDate(), "/").concat(date.getMonth() + 1, " - ").concat(date.getHours(), ":").concat(date.getMinutes());
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, _objectSpreadProps(_objectSpread({
        isRead: props.isRead
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Avatar, {
                children: !!props.avatar && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductImageWrapper, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .LazyImage */ .w, {
                        src: props.avatar,
                        alt: "",
                        borderRadius: 50,
                        contain: true
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ContentWrapper, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(HeaderWrapper, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TitleWrapper, {
                                children: props.title
                            }),
                            props.time && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TimeWrapper, {
                                children: formatDate
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MessageWrapper, {
                        dangerouslySetInnerHTML: {
                            __html: (0,_teko_utils__WEBPACK_IMPORTED_MODULE_4__/* .htmlDecode */ .l)(props.message)
                        }
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 31439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ htmlDecode; }
/* harmony export */ });
/* unused harmony export htmlEncode */
const htmlEncode = (html) => {
  return html.replace(/[\u00A0-\u9999<>\&]/g, function(i) {
    return "&#" + i.charCodeAt(0) + ";";
  });
};
const htmlDecode = (str) => {
  const e = document.createElement("textarea");
  e.innerHTML = str;
  return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
};




/***/ })

}]);